function copyFilter(filter) {
    return {
        field: filter.field,
        operator: filter.operator,
        value: filter.value
    };
}

function isSingleFilter(filter) {
    return !!filter && !!filter.field;
}

function isArrayOfFilters(filters) {
    return !!filters && filters.hasOwnProperty("length") && filters.every(isSingleFilter);
}

function isRecursiveArray(filters) {
    return !!filters && filters.hasOwnProperty("length") && filters.every(function(filter) {
        return isSingleFilter(filter) || isFlat(filter) || isRecursive(filter);
    });
}

function caseInsensitiveEqual(logic1, logic2) {
    return !!logic1 && !!logic2 && logic1.toUpperCase() === logic2.toUpperCase();
}

function isFlat(filter) {
    return !!filter && (caseInsensitiveEqual("AND", filter.logic) || caseInsensitiveEqual("OR", filter.logic)) && isArrayOfFilters(filter.filters);
}

function isRecursive(filter) {
    return !!filter && (caseInsensitiveEqual("AND", filter.logic) || caseInsensitiveEqual("OR", filter.logic)) && isRecursiveArray(filter.filters);
}

function doesLogicMatch(normalizedFilter, logic) {
    return caseInsensitiveEqual(logic, normalizedFilter.logic) || normalizedFilter.filters.length <= 1;
}

function flattenRecursive(recursive) {
    var logic = recursive.logic;
    var filters = [];
    recursive.filters
        .map(attemptFlatten)
        .forEach(function(normalizedFilter) {
            if (doesLogicMatch(normalizedFilter, logic)) {
                normalizedFilter.filters.forEach(function(filter) {
                    filters.push(filter)
                });
            } else {
                throw "This filter can't be flattened because the logical operators are not compatible.";
            }
        });
    return {
        logic: logic,
        filters: filters
    };
}

function attemptFlatten(filter) {
    if (isFlat(filter)) {
        return {
            logic: filter.logic,
            filters: filter.filters.map(copyFilter)
        };
    } else if (isArrayOfFilters(filter)) {
        return {
            logic: "and",
            filters: filter.map(copyFilter)
        };
    } else if (isSingleFilter(filter)) {
        return {
            logic: "and",
            filters: [copyFilter(filter)]
        };
    } else if (isRecursive(filter)) {
        return flattenRecursive(filter);
    } else {
        throw "Filters are in a format that isn't recognized."
    }
}

/**
 * Convert filters into a "flat" format.  If that is not possible, the input will be returned unmodified.
 */
export default function(filter) {
    try {
        return attemptFlatten(filter);
    } catch (e) {
        return filter;
    }
}
